export default __webpack_public_path__ + "static/media/mode-502.92d73f64.svg";